module.exports = __webpack_public_path__ + "img/SoftwareCopyright_15.7dd6dab1.png";